export default __webpack_public_path__ + "static/media/freshprep.4c090710.png";